import { capitalize } from 'lodash-es';

export const getSourceDomainName = (enumValue: string) => capitalize(enumValue.split('.')[0]);
